import { createContext } from 'react';

import type {
  CheckoutCollectionOptionsStateContextType,
  CheckoutFormAcceptTermConditionContextType,
  CheckoutFormRefStateContextType,
  CheckoutStateContextType,
} from '@/clientState/providers/checkout/types';
import { PaymentMethod } from '@/generated/graphql';
import type {
  AcquisitionContextType,
  AlternativePaymentMethodSelected,
  CheckoutPrimeEMLStatusContextType,
  CheckoutResponseStateContextType,
  InvoiceStateContextType,
  PaymentInstrumentTokenContextType,
  ShoppingBasketIdContextType,
  ShowSumbmitValidationContextType,
  SpecialRequestStateContextType,
} from '@/clientState/providers/checkout/types/CheckoutStateContext';

export const CheckoutStateContext = createContext<CheckoutStateContextType>({
  selectedPaymentMethod: {
    collectionMethodType: PaymentMethod.Creditcard,
    valid: false,
    id: undefined,
  },
  reset: false,
  resetIndividualFields: {
    cardNumberReset: false,
    cardExpirationDateReset: false,
    cardSecurityNumberReset: false,
    cardOwnerReset: false,
  },
  isValidCheckoutForm: false,
});

export const InvoiceStateContext = createContext<InvoiceStateContextType>({
  valid: true,
});

export const SaveCreditCardContext = createContext<boolean>(false);
export const SpecialRequestStateContext =
  createContext<SpecialRequestStateContextType>({
    valid: true,
  });
export const CheckoutResponseStateContext =
  createContext<CheckoutResponseStateContextType>({
    loading: false,
  });
export const CheckoutPrimeEMLStatusContext =
  createContext<CheckoutPrimeEMLStatusContextType>({
    open: false,
    setOpen: () => {
      /** */
    },
  });
export const ShowSumbmitValidationContext =
  createContext<ShowSumbmitValidationContextType>(false);
export const CheckoutCollectionOptionsStateContext =
  createContext<CheckoutCollectionOptionsStateContextType>({
    collectionOptions: [],
  });

export const CheckoutPrimeFunnelAdapterContext =
  createContext<AcquisitionContextType>({
    setAcquisition: () => {},
    isAcquisition: false,
  });

export const CheckoutFormAcceptTermConditionContext =
  createContext<CheckoutFormAcceptTermConditionContextType>([
    true,
    (): void => {
      /** */
    },
  ]);

export const CheckoutFormRefStateContext =
  createContext<CheckoutFormRefStateContextType>(() => {
    /** */
  });

export const PaymentInstrumentTokenContext =
  createContext<PaymentInstrumentTokenContextType>('');

export const AlternativePaymentMethodSelectedContext =
  createContext<AlternativePaymentMethodSelected>(false);

export const ShoppingBasketIdContext =
  createContext<ShoppingBasketIdContextType>(null);
